import React from 'react';
import { FlatContentCard } from '@shared/ui/atoms/FlatContentCard';
import styled from "styled-components";
import { BasicMovementIcon } from '@shared/ui/atoms/BasicMovementIcon';
import { useSelector } from "react-redux";
import { selectIconPack } from "@shared/store/auth.duck";
import { OFFICE_OPTION } from '@features/whereabouts/services/WhereaboutOptions';
import { BodyRegular, BodySmall } from '@shared/ui/atoms/fonts/Body';
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export function CreatingOfficeContentCard(props: Props) {
  const iconPack = useSelector(selectIconPack)
  return (
    <Container style={props?.style ?? {}}>
      <ColumnLeft>
        <BasicMovementIcon onClick={() => {}}
                           option={OFFICE_OPTION}
                           iconPack={iconPack} />
      </ColumnLeft>
      <Column>
        <BodyRegular weight={600}>Creating office locations?</BodyRegular>
        <BodySmall style={{marginBottom: 12}}>Create and manage multiple offices in the office management area instead for accurate reporting and office counts.</BodySmall>
        <OutlineButton link={'/manage/offices'} size={ButtonSize.Small} style={{width: 150}} text={'button.setup-offices'} />
      </Column>
    </Container>
  )
}

interface Props {
  style?: any;
}

const Container = styled(FlatContentCard)`
  display: flex;
  margin-bottom: 32px;
`

const ColumnLeft = styled.div`
  min-width: 100px;
 `

const Column = styled.div`
  padding-left: 24px;
 `
